import { Injectable } from '@angular/core';

// Ad-click signals sent with each order so the backend can report conversions to Meta / GA4
@Injectable({ providedIn: 'root' })
export class TrackingService {

    private cookie(name: string): string | null {
        const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
        return match ? decodeURIComponent(match[2]) : null;
    }

    private session(key: string): string | null {
        try { return sessionStorage.getItem(key); } catch { return null; }
    }

    /** Call once on app start: gclid / fbclid only exist on the landing URL. */
    captureClickIds(): void {
        try {
            const params = new URLSearchParams(window.location.search);
            const gclid = params.get('gclid');
            const fbclid = params.get('fbclid');
            if (gclid) sessionStorage.setItem('gclid', gclid);
            if (fbclid) sessionStorage.setItem('fbc', `fb.1.${Date.now()}.${fbclid}`);
        } catch { }
    }

    /** Attached to order placement requests as `tracking`. */
    getSignals() {
        const ga = this.cookie('_ga');
        const gclAw = this.cookie('_gcl_aw'); // GCL.<ts>.<gclid>
        return {
            surface: 'web',
            fbc: this.cookie('_fbc') || this.session('fbc'),
            fbp: this.cookie('_fbp'),
            gclid: this.session('gclid') || (gclAw ? gclAw.split('.').slice(2).join('.') : null),
            gaClientId: ga ? ga.split('.').slice(-2).join('.') : null,
        };
    }

    /** Must match the backend's event_id so Meta counts browser + server as one order. */
    eventId(type: string, orderId: any, eventName = 'Purchase'): string | null {
        if (!orderId) return null;
        return `${type === 'bulk' ? 'bulk' : 'std'}_${orderId}_${eventName}`;
    }
}
